import React from "react";
import { Lightbulb, X } from "lucide-react";
import { useFirstVisit } from "../../hooks/useFirstVisit";
import "./Onboarding.css";

const Hint = ({ id, children, icon: Icon = Lightbulb }) => {
  const [isFirstVisit, dismiss] = useFirstVisit(id);
  if (!isFirstVisit) return null;

  return (
    <div className="onboarding-hint">
      <Icon size={18} strokeWidth={2.25} className="onboarding-hint-icon" />
      <div className="onboarding-hint-text">{children}</div>
      <button className="onboarding-hint-close" onClick={dismiss} aria-label="Compris, fermer ce conseil">
        <X size={15} strokeWidth={2.25} />
      </button>
    </div>
  );
};

export default Hint;
